import { forwardRef } from "react";
import CrossIcon from "./Icons/CrossIcon";
import { createPortal } from "react-dom";

type Props = {
  children: React.ReactNode;
  toggleDialog: () => void;
  className: string;
};

const Modal = forwardRef<HTMLDialogElement, Props>(
  ({ children, toggleDialog, className }, ref) => {
    return createPortal(
      <dialog
        ref={ref}
        onClick={(e) => {
          if (e.currentTarget === e.target) {
            toggleDialog();
          }
        }}
        className={className}
      >
        <button type="button" className="float-end" onClick={toggleDialog}>
          <CrossIcon className="size-8 text-[#1A1D21]" />
        </button>

        <div>{children}</div>
      </dialog>,
      document.body
    );
  }
);

export default Modal;
